// @flow
import desktopImage from './welcome.png';
import { media } from '~/core/utils/style';
import mobileImage from './welcome-mobile.png';
import styled from 'styled-components';

const borderRadius = '10px';

export const MainWrapper = styled.div`
    width: 100vw;
    height: 100vh;
    position: absolute;
    z-index: 1000;
    background-color: rgba(35, 35, 35, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
`;

export const PopupWrapper = styled.div`
    position: absolute;
    width: 90%;
    height: auto;
    background: white;
    border-radius: ${borderRadius};
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);

    ${media.desktop`
		width: 50%;
	`};
`;

export const ImageContainer = styled.div`
    background-image: url(${mobileImage});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 100%;
    height: 200px;
    border-top-right-radius: ${borderRadius};
    border-top-left-radius: ${borderRadius};

    ${media.tablet`
		background-image: url(${desktopImage});
	`};
`;

export const MessageContainer = styled.div`margin-bottom: 20px;`;

export const TextContainer = styled.div`padding: 40px;`;



// WEBPACK FOOTER //
// ./src/components/widgets/new-website-popup/styles.js